import React, { useState } from 'react';
import './Dashboard.css';
import Myara from './Myara.js';
import TestMyara from './TestMyara.js';
import Hailbox from './Hailbox.js';
import Agritek from './Agritek.js';

const labels = [
    { key: 'myara', name: 'Myara' },
    { key: 'test', name: 'Test Myara' },
    { key: 'Hailbox', name: 'Hailbox' },
    { key: 'Agritek', name: 'Agritek' }
];

function Dashboard() {
    const [selectedLabel, setSelectedLabel] = useState('myara');
    const [youWantData, setYouWantData] = useState(true);

    const openLabel = (key) => {
        setSelectedLabel(key);
        if (key === 'myara' || key === 'Agritek') {
            setYouWantData(true);
        }
    };

    let displaySelectedLabel;

    switch (selectedLabel) {
        case 'myara':
            displaySelectedLabel = <Myara youWantData={youWantData} />;
            break;
        case 'Hailbox':
            displaySelectedLabel = <Hailbox />;
            break;
        case 'test':
            displaySelectedLabel = <TestMyara />;
            break;
        case 'Agritek':
            displaySelectedLabel = <Agritek youWantData={youWantData} />;
            break;
        default:
            displaySelectedLabel = null;
    }

    return (
        <div className="dashboard-page">
            <div className="page-header">
                <div className="header-title">
                    <h1>Dashboard Progetti Clienti</h1>
                    <span className="count-badge">Modulo Analytics</span>
                </div>
            </div>

            <div className="dashboard-stats-row">
                <div className="stat-card">
                    <span className="stat-title">Clienti Attivi</span>
                    <span className="stat-value">4 Progetti</span>
                </div>
                <div className="stat-card">
                    <span className="stat-title">Stato Sincronizzazione</span>
                    <span className="stat-value live">Sincronizzato</span>
                </div>
                <div className="stat-card">
                    <span className="stat-title">Sotto-Sistema Selezionato</span>
                    <span className="stat-value active-name">{selectedLabel || 'Seleziona'}</span>
                </div>
            </div>

            <div className="dashboard-tabs">
                {labels.map((item) => (
                    <button
                        key={item.key}
                        onClick={() => openLabel(item.key)}
                        className={`tab-btn ${selectedLabel === item.key ? 'active' : ''}`}
                    >
                        {item.name}
                    </button>
                ))}
            </div>

            <div className="dashboard-sub-container">
                {displaySelectedLabel}
            </div>
        </div>
    );
}

export default Dashboard;

